class Optimizely {
  inferName(data: { category: string; action: string; label: string; }) {
    const normalize = (str: string) => str.toLowerCase().replace(/\s/g, '-');

    return `${normalize(data.category)}.${normalize(data.action)}.${normalize(data.label)}`;
  }

  track(data: any) {
    const name = data.optimizelyValue;
    const inferredName = this.inferName(data);

    if (typeof window.optimizely !== 'undefined') {
      window.optimizely.push({
        type: 'event',
        eventName: name || inferredName
      });
    }
  }
}

export { Optimizely };

export default new Optimizely();
